export default __webpack_public_path__ + "bf8f03402d046fc47b249ecf80dcf66b.svg";